import request from "@/utils/request";
import { buildUploadHeaders } from "@/utils/uploadApiHelper";

export async function upload(formData) {
  return request({
    url: "/file/upload",
    method: "POST",
    headers: await buildUploadHeaders(process.env.VUE_APP_BASE_API),
    data: formData,
  });
}
